module.exports = __webpack_public_path__ + "static/media/explore_04.9771e301.jpg";